import styled from 'styled-components'
import { breakpoints } from '../../../../constants'
import {
	WHITE,
	MEDIUMORANGE,
	INPUTGRAY,
	GRAY,
} from '../../../../styles/colors.style'

export const BoxCancel = styled.div`
	display: flex;
	flex-direction: column;
	width: 90%;
	margin: 45px auto;

	@media (min-width: ${breakpoints.MOBILE}px) {
		width: 500px;
		min-height: 150px;
		margin-bottom: 90px;
	}

	@media (max-width: ${breakpoints.NOTEBOOK}px) {
		margin: 45px auto;
	}

	p {
		text-align: center;
		font: 2.2rem/45px 'Source Sans Pro';
	}
	input[type='text'],
	textarea {
		margin: 0 auto 10px;
		padding: 4px;
		font: 16px/45px 'Source Sans Pro';
		border-radius: 6px;
		border: 1px solid ${INPUTGRAY};
		color: ${GRAY};
		display: block;
		background: ${WHITE};
		outline: none;
		height: 45px;
		width: 100%;
	}

	button {
		border: 0;
		margin: 0px auto;
		background: ${MEDIUMORANGE};
		color: ${WHITE};
		font: 600 2.5rem/25px 'Source Sans Pro';
		cursor: pointer;
		padding: 0 16px;
		height: 45px;
		border-radius: 5px;

		&:disabled {
			opacity: 0.5;
			cursor: initial;
		}

		&:focus {
			outline: none;
		}

		&:hover:disabled {
			opacity: 0.5;
			transition: all 0.5s;
		}

		&:hover {
			opacity: 0.8;
			transition: all 0.5s;
		}
	}
`

export const BoxModal = styled.div`
	background: ${WHITE};
	padding: 40px 30px;
	display: flex;
	flex-direction: column;

	@media (min-width: ${breakpoints.MOBILE}px) {
		width: 500px;
	}

	h3 {
		text-align: center;
		color: rgba(0, 0, 0, 0.87);
	}

	p {
		font: 2.4rem/45px 'Source Sans Pro';
	}
	button {
		background: ${MEDIUMORANGE};
		color: ${WHITE};
		font: 600 2.2rem/25px 'Source Sans Pro';
		cursor: pointer;
		width: 202px;
		height: 45px;
		border-radius: 5px;
		align-self: flex-end;
		border: 0;
		&:disabled {
			opacity: 0.5;
			cursor: initial;
		}
		&:focus {
			outline: none;
		}
		&:hover {
			opacity: 0.8;
			transition: all 0.5s;
		}
		&:hover:disabled {
			opacity: 0.5;
			transition: all 0.5s;
		}
	}

	textarea {
		height: 200px;
		resize: none;
		margin: 20px 0;
		width: 100%;
		padding: 10px 0;
	}
`
